<template>
  <header class="bg-white border-bottom shadow-sm sticky-top">
    <nav class="navbar navbar-expand-lg navbar-light py-3">
      <div class="mr-lg-3 mr-xl-4">
        <a class="navbar-brand" :href="`${RedirectUrl.LANDING_PAGE}`">
          <svg
            class="d-none d-xl-inline-block"
            width="136"
            height="40"
            viewBox="0 0 136 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M49.8412 11.9459L37.7063 0.813542C37.0712 0.220443 36.6671 0 35.8063 0H25.1621H14.5125C13.657 0 13.2529 0.220443 12.6178 0.813542L0.477628 11.9459C0.15746 12.2451 0 12.6965 0 13.1479C0 13.5993 0.15746 14.0506 0.477628 14.3446L23.9496 35.9165C24.2645 36.2105 24.7422 36.3784 25.1621 36.3784C25.5819 36.3784 26.0596 36.2105 26.3745 35.9165L49.8465 14.3446C50.1666 14.0454 50.3241 13.594 50.3241 13.1479C50.3189 12.6965 50.1614 12.2451 49.8412 11.9459Z"
              fill="#007B83"
            ></path>
            <path
              d="M50.1089 17.4465C49.8202 17.1316 49.3321 17.1106 49.0172 17.3993L26.2958 38.2522C25.9389 38.0842 25.54 37.9898 25.1621 37.9898C24.7894 37.9898 24.3853 38.0842 24.0336 38.2522L1.31216 17.394C0.997244 17.1054 0.509119 17.1264 0.220443 17.4413C-0.0682333 17.7562 -0.0472387 18.2443 0.267681 18.533L23.43 39.7953C23.6557 40 23.9811 40.0577 24.2645 39.9318C24.3485 39.895 24.4272 39.8425 24.4955 39.7743C24.6582 39.6326 24.9311 39.5329 25.1673 39.5329C25.4035 39.5329 25.6712 39.6274 25.8339 39.7691C25.9021 39.8373 25.9808 39.895 26.0701 39.9318C26.1698 39.9738 26.2748 39.9948 26.3797 39.9948C26.5739 39.9948 26.7576 39.9213 26.9046 39.7901L50.0617 18.5278C50.3766 18.2496 50.3976 17.7562 50.1089 17.4465Z"
              fill="#49BCBD"
            ></path>
            <path
              d="M24.6319 6.77602L23.9864 6.17242H16.4073V9.25863H21.551V11.3476C21.551 11.8777 21.0734 12.3081 20.5432 12.3081H15.3943V6.17242L12.9484 6.18292L12.3081 6.76552V19.9187L12.9747 20.5222H15.3838V15.3891C15.3838 15.3891 21.4355 15.3838 21.4775 15.3786C23.2253 15.3366 24.6319 13.9089 24.6319 12.1506V6.77602Z"
              fill="white"
            ></path>
            <path
              d="M31.8121 14.8904V14.8747L33.4759 13.3473L37.9478 9.25863H37.953V6.77602L37.2917 6.17242H34.2317H31.8121H29.3295H26.3168L25.6712 6.76552V9.25863H25.6764L27.9019 11.2951H30.7834V10.8647L29.6392 9.80974C29.3137 9.50532 29.4135 9.25863 29.8544 9.25863H31.8121H33.7698C34.2107 9.25863 34.3105 9.50532 33.985 9.80974L31.8121 11.8095L26.8889 16.3286L25.6764 17.4413H25.6712V19.9239L26.3168 20.5275H29.3977H31.8173H34.3H37.3127L37.9583 19.9239V17.4413H37.953L35.7276 15.4048H32.8461V15.8352L33.9903 16.8902C34.3157 17.1946 34.216 17.4413 33.7751 17.4413H31.8173H29.8596C29.4187 17.4413 29.319 17.1946 29.6444 16.8902L31.8121 14.8904Z"
              fill="white"
            ></path>
            <path
              d="M132.293 29.7074H122.2V28.6157H132.293V27.3402H122.2V27.2563V24.5375H120.547V33.4549H122.2V30.9881H132.293V29.7074Z"
              fill="#007B83"
            ></path>
            <path
              d="M135.999 18.7954V17.5148H128.656L128.199 16.2341H126.54L126.997 17.5148H119.339V18.7954H123.633L120.447 21.3305V22.6164C120.447 22.6164 133.978 22.6164 133.994 22.6164C134.576 22.6164 135.043 22.1441 135.043 21.5667C135.043 21.446 135.017 21.3358 134.98 21.2256C134.97 21.1888 134.954 21.1468 134.933 21.1153C134.917 21.0786 134.896 21.0471 134.875 21.0104C134.87 20.9999 134.86 20.9841 134.854 20.9736C134.791 20.8791 134.713 20.7899 134.618 20.7059L133.07 19.357H130.991L132.876 20.8424C132.944 20.8896 132.991 20.9736 132.991 21.0681C132.991 21.2151 132.87 21.3305 132.729 21.3305H122.468L125.617 18.7954H135.999Z"
              fill="#007B83"
            ></path>
            <path
              d="M123.328 25.8234H133.353C133.353 25.8234 133.358 31.1613 133.358 31.1718C133.358 31.6966 132.933 32.1218 132.408 32.1218C132.398 32.1218 128.577 32.1218 127.958 32.1218V33.4602H133.128C134.167 33.4549 135.007 32.6099 135.007 31.5654C135.007 31.5602 135.007 24.5375 135.007 24.5375H123.334V25.8234H123.328Z"
              fill="#007B83"
            ></path>
            <path
              d="M112.044 29.6601C112.353 29.1615 112.621 28.6314 112.852 28.0646C113.555 26.4217 113.923 23.9234 113.949 21.0996C113.949 20.9736 113.949 19.42 113.949 18.8164H114.563V17.478C113.949 17.478 110.123 17.478 110.112 17.478C109.587 17.478 109.167 17.0581 109.162 16.5333C109.162 16.4545 109.162 16.3601 109.162 16.2341H107.514C107.514 16.6015 107.514 16.8062 107.514 16.9217C107.514 17.9609 108.354 18.8059 109.393 18.8164H112.485C112.485 19.42 112.485 20.9789 112.485 21.0996C112.479 23.7764 112.217 25.9913 111.697 27.2143C111.545 27.6394 111.356 28.0488 111.141 28.4425C110.411 27.2353 110.002 25.5085 109.913 23.262C109.855 20.9789 109.907 20.0289 109.907 19.9869H108.464C108.464 20.0236 108.422 21.1468 108.469 23.2463C108.585 25.9493 109.188 28.0855 110.291 29.6496C109.561 30.5104 108.601 31.2242 107.409 31.8121V33.4392C108.999 32.7726 110.259 31.8436 111.193 30.7834C112.128 31.7754 113.288 32.7936 114.663 33.4392V31.8121C113.534 31.2662 112.742 30.4107 112.044 29.6601Z"
              fill="#007B83"
            ></path>
            <path
              d="M106.832 17.1578H105.178C105.147 17.2786 105.11 17.4098 105.068 17.5358H103.331V16.2603H101.683V17.5358H99.0953V18.8112H101.683V21.3253H97.9563V22.6007H102.759C101.651 24.1176 100.114 25.3195 97.9563 25.54V26.8259C99.1845 26.7261 100.26 26.364 101.2 25.8234H103.599L101.688 27.1985V28.3322L97.9616 28.7154V29.8911V29.9961L101.688 29.6392V30.9513C101.688 31.3975 101.615 31.7071 101.468 31.8856C101.294 32.1008 100.974 32.211 100.518 32.211H99.1005V33.4287H101.216C101.972 33.4287 102.528 33.2345 102.88 32.8408C103.205 32.4734 103.347 32.0168 103.347 31.1193V29.4869L107.257 29.109V29.0251V27.8441V27.8336L105.278 28.0226L103.341 28.201V28.0436L106.401 25.8339V24.5585H102.895C103.509 23.9706 104.045 23.3093 104.501 22.6112H107.252V21.3358H105.252C106.039 19.8189 106.538 18.2916 106.832 17.1578ZM103.567 21.3305H103.331V18.8164H104.659C104.375 19.63 104.019 20.496 103.567 21.3305Z"
              fill="#007B83"
            ></path>
            <path
              d="M84.9396 28.39L84.0369 28.5054V17.5358H84.9396V16.2341H77.2556V17.5358H82.3783V21.3463H79.7592V18.8007H78.1164L78.1006 29.277L77.2504 29.3872V30.6679L82.3731 30.0171V33.4182H84.0264V29.8071L84.9291 29.6916V28.39H84.9396ZM82.3835 28.7259L79.7645 29.067V25.8286H82.3835V28.7259ZM82.3835 24.5427H79.7645V22.6217H82.3835V24.5427Z"
              fill="#007B83"
            ></path>
            <path
              d="M91.553 26.9676H89.8996C90.0781 28.4057 90.8234 31.5234 93.9044 33.4497H93.9096L93.9044 31.8226C92.0988 30.2847 91.7262 28.0961 91.553 26.9676Z"
              fill="#007B83"
            ></path>
            <path
              d="M84.9134 31.8226L84.9082 33.4497H84.9134C87.9944 31.5182 88.7397 28.4057 88.9181 26.9676H87.2648C87.0916 28.0961 86.7189 30.2847 84.9134 31.8226Z"
              fill="#007B83"
            ></path>
            <path
              d="M91.4532 25.8444C92.4925 25.8391 93.3322 24.9941 93.3322 23.9496C93.3322 23.9339 93.3322 16.2341 93.3322 16.2341H88.3618V17.5148H91.6789C91.6789 17.5148 91.6842 23.5245 91.6842 23.556C91.6842 24.0808 91.259 24.506 90.7342 24.506C90.7237 24.506 87.2438 24.506 87.2438 24.506V16.2341H85.5905V25.8444H91.4532Z"
              fill="#007B83"
            ></path>
            <path
              d="M68.2122 25.8339H71.2459C71.2459 25.8339 71.2512 31.1455 71.2512 31.1718C71.2512 31.6966 70.826 32.1218 70.3011 32.1218C70.2907 32.1218 67.1152 32.1218 67.1152 32.1218V24.5112H65.4619V33.4602H71.0202C72.0594 33.4549 72.8992 32.6099 72.8992 31.5654C72.8992 31.5497 72.8992 24.548 72.8992 24.548H68.2122V25.8339Z"
              fill="#007B83"
            ></path>
            <path
              d="M58.9903 25.8339H62.024C62.024 25.8339 62.0293 31.1455 62.0293 31.1718C62.0293 31.6966 61.6041 32.1218 61.0793 32.1218C61.0688 32.1218 57.8933 32.1218 57.8933 32.1218V24.5112H56.24V33.4602H61.7983C62.8376 33.4549 63.6773 32.6099 63.6773 31.5654C63.6773 31.5497 63.6773 24.548 63.6773 24.548H58.9903V25.8339V25.8339Z"
              fill="#007B83"
            ></path>
            <path
              d="M57.9773 19.4935V20.0079V22.6217H69.3196C70.3589 22.6164 71.1987 21.7714 71.1987 20.7269C71.1987 20.7112 71.1987 16.2288 71.1987 16.2288H61.2367V17.5095H69.5453C69.5453 17.5095 69.5506 20.3018 69.5506 20.328C69.5506 20.8529 69.1255 21.278 68.6006 21.278C68.5901 21.278 59.6306 21.278 59.6306 21.278V19.4778C60.166 19.1838 60.5386 18.617 60.5386 17.9609C60.5386 17.0004 59.7618 16.2236 58.8013 16.2236C57.8461 16.2236 57.064 17.0004 57.064 17.9609C57.0588 18.6327 57.4314 19.1996 57.9773 19.4935ZM58.7961 17.4675C59.0743 17.4675 59.3 17.6932 59.3 17.9714C59.3 18.2496 59.0743 18.4753 58.7961 18.4753C58.5179 18.4753 58.2922 18.2496 58.2922 17.9714C58.2922 17.6932 58.5179 17.4675 58.7961 17.4675Z"
              fill="#007B83"
            ></path>
            <path
              d="M122.901 6.28264H120.844H120.592H120.067C119.49 6.28264 119.18 6.60281 119.18 7.20115V7.84149V8.07243V10.681C119.18 11.2846 119.485 11.5995 120.067 11.5995H122.901C123.479 11.5995 123.788 11.2794 123.788 10.681V7.1959C123.788 6.60281 123.484 6.28264 122.901 6.28264ZM123.022 10.4448C123.022 10.6548 122.98 10.7492 122.949 10.7912C122.901 10.8542 122.807 10.891 122.66 10.891H120.309C120.167 10.891 120.067 10.8595 120.02 10.7912C119.988 10.7492 119.946 10.6495 119.946 10.4448V7.44259C119.946 7.23265 119.988 7.13817 120.02 7.09618C120.067 7.0332 120.167 6.99646 120.309 6.99646H122.66C122.802 6.99646 122.901 7.02795 122.949 7.09618C122.98 7.13817 123.022 7.23789 123.022 7.44259V10.4448Z"
              fill="#007B83"
            ></path>
            <path
              d="M110.515 10.2926C110.184 10.2926 109.916 10.5603 109.916 10.8909C109.916 11.2216 110.184 11.4893 110.515 11.4893C110.845 11.4893 111.113 11.2216 111.113 10.8909C111.113 10.5603 110.845 10.2926 110.515 10.2926Z"
              fill="#007B83"
            ></path>
            <path
              d="M88.7327 6.28264H87.4992V7.0017H88.7274C89.5619 7.0017 89.9661 7.36911 89.9661 8.12492V9.79399C89.9661 10.5498 89.5619 10.9172 88.7274 10.9172H86.9114V7.52132V7.0017V6.28264H86.2291H86.1346V6.37711V11.547V11.6415H86.2291H88.7327C89.3677 11.6415 89.8664 11.4841 90.2075 11.1744C90.5592 10.8595 90.7376 10.3976 90.7376 9.80973V8.10917C90.7376 7.52657 90.5592 7.06994 90.2075 6.75502C89.8611 6.44535 89.3625 6.28264 88.7327 6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M78.7287 6.28264H75.4798V7.00695H78.7287V6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M74.9444 10.4553V8.53956V8.42409V7.44784V6.28789H74.7607C74.4091 6.28789 74.1256 6.57131 74.1256 6.92297V8.54481V10.9907C74.1256 11.3423 74.4091 11.6258 74.7607 11.6258H75.0442H78.7287V10.9015H75.3223C75.1124 10.8647 74.9444 10.681 74.9444 10.4553Z"
              fill="#007B83"
            ></path>
            <path
              d="M117.831 6.28264H114.635V7.00695H117.831V6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M114.047 10.4553V8.53956V8.42409V7.44784V6.28789H113.863C113.512 6.28789 113.228 6.57131 113.228 6.92297V8.54481V10.9907C113.228 11.3423 113.512 11.6258 113.863 11.6258H114.147H117.831V10.9015H114.425C114.215 10.8647 114.047 10.681 114.047 10.4553Z"
              fill="#007B83"
            ></path>
            <path
              d="M96.3957 9.23764C96.4219 9.23764 96.4429 9.21664 96.4429 9.1904C96.4429 9.16416 96.4429 9.02769 96.4429 8.89123V8.88073C96.4429 8.74426 96.4429 8.6078 96.4429 8.58155C96.4429 8.55531 96.4219 8.53432 96.3957 8.53432C96.3694 8.53432 96.233 8.53432 96.0965 8.53432H93.5929V9.23764H96.0965C96.233 9.23764 96.3694 9.23764 96.3957 9.23764Z"
              fill="#007B83"
            ></path>
            <path
              d="M96.7159 6.28264H93.5929V7.0017H96.7159V6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M92.9578 10.4763V6.28264H92.7741C92.4225 6.28264 92.139 6.56607 92.139 6.91773V11.0064C92.139 11.3581 92.4225 11.6415 92.7741 11.6415H93.0576H96.7159V10.9172H93.341C93.131 10.891 92.9578 10.702 92.9578 10.4763Z"
              fill="#007B83"
            ></path>
            <path
              d="M82.8857 6.54507C82.8647 6.49258 82.8384 6.41385 82.8174 6.36662C82.8017 6.31938 82.7387 6.28264 82.6862 6.28264C82.6862 6.28264 82.2033 6.28264 82.1613 6.28264C82.1141 6.28264 82.0616 6.31938 82.0459 6.37187C82.0301 6.4191 81.9986 6.50308 81.9776 6.55032L80.1354 11.6363H80.9279L82.2978 7.87823C82.2978 7.87823 82.4185 7.54756 82.5707 7.87823L83.1586 9.51056C83.1796 9.56305 83.1953 9.61029 83.0746 9.61029H82.2768L82.0196 10.3294H83.3475C83.4 10.3294 83.4578 10.3713 83.4735 10.4238L83.9249 11.6363H84.7384L82.8857 6.54507Z"
              fill="#007B83"
            ></path>
            <path
              d="M70.8715 6.54507C70.8505 6.49258 70.8242 6.41385 70.8033 6.36662C70.7875 6.31938 70.7245 6.28264 70.672 6.28264C70.672 6.28264 70.1892 6.28264 70.1472 6.28264C70.0999 6.28264 70.0474 6.31938 70.0317 6.37187C70.016 6.4191 69.9845 6.50308 69.9635 6.55032L68.1212 11.6363H68.9137L70.2836 7.87823C70.2836 7.87823 70.4044 7.54756 70.5566 7.87823L71.1444 9.51056C71.1654 9.56305 71.1812 9.61029 71.0604 9.61029H70.2626L70.0055 10.3294H71.3334C71.3859 10.3294 71.4436 10.3713 71.4593 10.4238L71.9107 11.6363H72.7243L70.8715 6.54507Z"
              fill="#007B83"
            ></path>
            <path
              d="M102.489 6.28264H102.09C101.865 6.28264 101.849 6.40336 101.802 6.52408L100.631 9.91471L100.08 11.631C100.08 11.631 100.19 11.631 100.248 11.631C100.311 11.631 100.4 11.631 100.469 11.631C100.537 11.631 100.626 11.631 100.689 11.631C100.794 11.631 100.904 11.5943 100.983 11.3791L101.865 8.83348C101.891 8.75475 101.933 8.80724 101.933 8.86498V10.1089V11.6363H102.342H102.752V10.1089V6.53982C102.747 6.42435 102.652 6.28264 102.489 6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M100.075 9.41084L99.0778 6.52933C99.0305 6.40861 99.0095 6.28789 98.7891 6.28789H98.4007C98.238 6.28789 98.1435 6.42435 98.1435 6.53982V10.1089V11.6363H98.5529V11.61V11.6363H98.9623V10.1089V8.91222C98.9623 8.85448 98.999 8.80199 99.0305 8.88072L99.6551 10.6548L100.075 9.41084Z"
              fill="#007B83"
            ></path>
            <path
              d="M129.494 6.28264H129.095C128.869 6.28264 128.853 6.40336 128.806 6.52408L127.636 9.91471L127.085 11.631C127.085 11.631 127.195 11.631 127.253 11.631C127.316 11.631 127.405 11.631 127.473 11.631C127.541 11.631 127.63 11.631 127.693 11.631C127.798 11.631 127.909 11.5943 127.987 11.3791L128.869 8.83348C128.895 8.75475 128.932 8.80724 128.932 8.86498V10.1089V11.6363H129.342H129.751V10.1089V6.53982C129.751 6.42435 129.656 6.28264 129.494 6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M127.079 9.41084L126.082 6.52933C126.035 6.40861 126.014 6.28789 125.793 6.28789H125.405C125.242 6.28789 125.148 6.42435 125.148 6.53982V10.1089V11.6363H125.557V11.61V11.6363H125.967V10.1089V8.91222C125.967 8.85448 126.003 8.80199 126.035 8.88072L126.659 10.6548L127.079 9.41084Z"
              fill="#007B83"
            ></path>
            <path
              d="M104.961 6.40861C104.93 6.36137 104.904 6.31413 104.893 6.30363C104.888 6.29314 104.867 6.28264 104.851 6.28264C104.836 6.28264 104.783 6.28264 104.725 6.28264H104.263C104.211 6.28264 104.127 6.28264 104.08 6.28264C104.032 6.28264 104.017 6.31413 104.038 6.35612C104.064 6.39811 104.106 6.46634 104.137 6.51358L105.402 8.80724L105.849 8.10392L104.961 6.40861Z"
              fill="#007B83"
            ></path>
            <path
              d="M108.405 6.28264H107.964C107.911 6.28264 107.854 6.28264 107.838 6.28264C107.822 6.28264 107.806 6.29314 107.796 6.30363C107.791 6.31413 107.759 6.36137 107.728 6.40861L105.833 9.43708V11.4421C105.833 11.4946 105.833 11.5628 105.833 11.589V11.6363H105.88C105.906 11.6363 105.969 11.6363 106.027 11.6363H106.452C106.505 11.6363 106.573 11.6363 106.599 11.6363H106.646V11.589C106.646 11.5628 106.646 11.4946 106.646 11.4421V9.57879C106.646 9.52631 106.673 9.44233 106.699 9.39509L108.525 6.50833C108.557 6.46109 108.599 6.39286 108.625 6.35087C108.651 6.30888 108.63 6.27739 108.583 6.27739C108.541 6.28264 108.457 6.28264 108.405 6.28264Z"
              fill="#007B83"
            ></path>
            <path
              d="M60.7731 6.50308L60.5316 6.27739H57.7026V7.42684H59.6236V8.20889C59.6236 8.40834 59.4452 8.5658 59.2457 8.5658H57.3247V6.27214L56.4114 6.27739L56.17 6.49258V11.4053L56.4167 11.631H57.3195V9.71526C57.3195 9.71526 59.5816 9.71526 59.5974 9.71001C60.2482 9.69426 60.7731 9.1589 60.7731 8.50282V6.50308Z"
              fill="#49BCBD"
            ></path>
            <path
              d="M64.3474 9.5368V9.53155L64.9667 8.95945L66.6358 7.43209V6.50308L66.3891 6.27739H65.2449H64.3422H63.4131H62.2899L62.0485 6.49783V7.42684L62.8778 8.1879H63.9538V8.03044L63.5234 7.63679C63.4026 7.52132 63.4394 7.43209 63.6021 7.43209H64.3317H65.0612C65.2239 7.43209 65.2607 7.52657 65.1399 7.63679L64.3264 8.3821L62.4894 10.0722L62.038 10.4868V11.4158L62.2794 11.6415H63.4289H64.3317H65.2607H66.3839L66.6253 11.4158V10.4868L65.796 9.72576H64.7201V9.88846L65.1504 10.2821C65.2712 10.3976 65.2344 10.4868 65.0717 10.4868H64.3422H63.6126C63.4499 10.4868 63.4131 10.3923 63.5339 10.2821L64.3474 9.5368Z"
              fill="#49BCBD"
            ></path>
          </svg>

          <svg
            class="d-xl-none"
            width="50"
            height="40"
            viewBox="0 0 50 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M49.5229 11.9458L37.4674 0.811815C36.8323 0.22109 36.4342 0 35.5794 0H25H14.4171C13.5658 0 13.1642 0.22109 12.5326 0.811815L0.473706 11.9458C0.157902 12.2429 0 12.6954 0 13.1445C0 13.597 0.157902 14.0461 0.473706 14.3432L23.7951 35.9168C24.1109 36.2138 24.5846 36.3797 25 36.3797C25.4153 36.3797 25.8891 36.2138 26.2049 35.9168L49.5263 14.3432C49.8421 14.0461 50 13.5936 50 13.1445C50 12.6954 49.8421 12.2429 49.5229 11.9458Z"
                fill="#007B83"
              ></path>
              <path
                d="M49.7872 17.4454C49.5023 17.131 49.0149 17.1103 48.7025 17.397L26.1294 38.252C25.7759 38.0827 25.3777 37.9894 25.0035 37.9894C24.6328 37.9894 24.2346 38.0827 23.881 38.252L1.30448 17.3935C0.992111 17.1068 0.504675 17.1275 0.219765 17.4419C-0.0651451 17.7563 -0.0445493 18.2468 0.267822 18.5335L23.2837 39.7962C23.5069 40.0034 23.833 40.0587 24.1144 39.9343C24.2003 39.8963 24.2758 39.8445 24.341 39.7789C24.5023 39.6372 24.7735 39.5371 25.0069 39.5336C25.2404 39.5336 25.5047 39.6303 25.666 39.7685C25.7347 39.8376 25.8136 39.8929 25.9029 39.9343C26.0024 39.9792 26.1054 40 26.2118 40C26.404 40 26.5894 39.9274 26.7301 39.7962L49.7392 18.537C50.055 18.2468 50.0756 17.7563 49.7872 17.4454Z"
                fill="#49BCBD"
              ></path>
              <path
                d="M24.4782 6.77434L23.8397 6.1698H16.3051V9.25469H21.4163V11.3447C21.4163 11.8767 20.9392 12.305 20.414 12.305H15.2993V6.17325L12.8724 6.18361L12.2339 6.76743V19.9223L12.8964 20.5268H15.2924V15.3899C15.2924 15.3899 21.3064 15.3865 21.3476 15.383C23.0811 15.3416 24.4816 13.9114 24.4816 12.1565L24.4782 6.77434Z"
                fill="white"
              ></path>
              <path
                d="M31.6113 14.889V14.8752L33.2658 13.3483L37.7111 9.25815H37.718V6.7778L37.0589 6.17326H34.0176H31.6147H29.1432H26.15L25.5115 6.76398V9.2547H25.5184L27.729 11.2894H30.5918V10.8576L29.4522 9.80397C29.1295 9.50342 29.229 9.2547 29.6684 9.2547H31.6147H33.5611C34.0004 9.2547 34.0965 9.50342 33.7773 9.80397L31.6182 11.8041V11.8076L26.7232 16.3296L25.5149 17.4419H25.5081V19.9223L26.1465 20.5268H29.205H31.6079H34.0759H37.0692L37.7077 19.9223V17.4419H37.7008L35.4902 15.4072H32.6274V15.839L33.767 16.8927C34.0897 17.1932 33.9901 17.4419 33.5508 17.4419H31.6147H29.6684C29.229 17.4419 29.1329 17.1932 29.4522 16.8927L31.6113 14.889Z"
                fill="white"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="50" height="40" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </a>
        <span class="d-none d-md-inline-block" rel="nofollow">
          <img
            src="https://resources.pzacademy.com/image/logo/cbiadp.png"
            height="36"
            alt="中国品牌创新发展工程"
          />
        </span>
        <!-- <a
          class="d-none d-md-inline-block"
          href="https://www.garp.org/#!/frm/exam-preparation-providers/pzacademy-co-ltd"
          target="_blank"
        >
          <img src="https://resources.pzacademy.com/image/logo/garp_logo.png" height="50" />
        </a> -->
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavId"
        aria-controls="collapsibleNavId"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="collapsibleNavId">
        <div class="border-top p-4 mx-n3 mt-3 text-center clearfix d-lg-none">
          <a
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            :href="`${RedirectUrl.MALL_PAGE}`"
            >品职商城</a
          >
          <router-link
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            to="/qa"
            v-if="p_isLogin"
            >有问必答</router-link
          >
          <a
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            :href="`${RedirectUrl.QA_QUESTION_LIST_PAGE}`"
            v-else
            >有问必答</a
          >
          <!-- <router-link class="text-dark px-4 py-3 text-nowrap d-inline-block"
          to="/mall/other"><span class="">金融</span>小课</router-link>-->

          <!-- <a
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            :href="`${RedirectUrl.TEACHERS_PAGE}`"
          >
            <span class>顶尖</span>师资
          </a>-->
          <a
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            :href="`${RedirectUrl.ARTICLES_PAGE}`"
            target="_blank"
          >
            <span class>原创</span>文章
          </a>

          <a
            class="text-dark px-4 py-3 text-nowrap d-inline-block"
            :href="`${RedirectUrl.READER_PAGE}`"
          >
            <span class>读者</span>中心
          </a>

          <!-- <PZLink
            extraClass="text-dark px-4 py-3 text-nowrap d-inline-block"
            :isExtenalPath="isFromClass"
            :linkStr="RedirectUrl.REFERRAL_PAGE"
          >
            <span class="text-dark">🧧</span>邀请得
            <span class>红包</span>
          </PZLink>-->

          <div class="row mt-4 justify-content-between">
            <div class="col" v-if="p_isLogin">
              <PZLink
                extraClass="btn btn-outline-info px-4 px-md-5"
                :isExtenalPath="isFromClass"
                :linkStr="RedirectUrl.DASHBOARD_PAGE"
              >
                <span class>进入课程</span>
              </PZLink>
            </div>
            <div class="col-6" v-if="!p_isLogin">
              <PZLink
                extraClass="btn btn-outline-info px-4 px-md-5"
                :isExtenalPath="isFromClass"
                :linkStr="RedirectUrl.TRAIL_LESSON_20426_PAGE"
                >学习体验</PZLink
              >
            </div>
            <div class="col-6" v-if="!p_isLogin">
              <a
                href="javascript:undefined"
                class="btn btn-light px-4 px-md-5"
                @click.prevent="p_gotoLogin"
                >登录 | 注册</a
              >
            </div>
          </div>
        </div>

        <ul class="navbar-nav mr-auto d-none d-lg-flex">
          <li class="nav-item">
            <a
              class="nav-link px-lg-2 px-xl-3"
              :href="`${RedirectUrl.MALL_PAGE}`"
              >品职商城</a
            >
          </li>
          <li class="nav-item" v-if="p_isLogin">
            <router-link class="nav-link px-lg-2 px-xl-3" to="/qa"
              >有问必答</router-link
            >
          </li>
          <li class="nav-item" v-else>
            <a
              class="nav-link px-lg-2 px-xl-3"
              :href="`${RedirectUrl.QA_QUESTION_LIST_PAGE}`"
              >有问必答</a
            >
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link px-lg-2 px-xl-3"
                         to="/mall/other"><span class="">金融</span>小课</router-link>
          </li>-->
          <!-- <li class="nav-item">
            <a class="nav-link px-lg-2 px-xl-3" :href="`${RedirectUrl.TEACHERS_PAGE}`">
              <span class>顶尖</span>师资
            </a>
          </li>-->

          <li class="nav-item">
            <a
              class="nav-link px-lg-2 px-xl-3"
              :href="`${RedirectUrl.ARTICLES_PAGE}`"
              target="_blank"
            >
              <span class>原创</span>文章
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link px-lg-2 px-xl-3"
              :href="`${RedirectUrl.READER_PAGE}`"
            >
              <span class>读者</span>中心
            </a>
          </li>
        </ul>
        <ul class="navbar-nav d-none d-lg-flex">
          <!-- <li class="nav-item">
            <PZLink
              extraClass="nav-link px-lg-2 px-xl-3"
              :isExtenalPath="isFromClass"
              :linkStr="RedirectUrl.REFERRAL_PAGE"
            >
              <span class="text-dark">🧧</span>邀请得
              <span class>红包</span>
            </PZLink>
          </li>-->
          <li class="nav-item nav-item dropdown" v-show="!p_isInCnIframe">
            <a
              href="javascript:undefined"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="nav-link px-lg-2 px-xl-3"
            >
              App
              <span class>下载</span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right dropdown-contact position-absolute shadow p-4 text-center"
              aria-labelledby="navbarDropdown"
            >
              <h5>手机上的品职教育</h5>
              <p class="mb-3 text-secondary">
                随时随地学习课程，支持音视频下载！
              </p>
              <div class="d-flex align-items-center">
                <img
                  src="https://resources.pzacademy.com/image/qrcode/app-store-qr.png"
                  width="150"
                  height="150"
                />
                <ul class="list-unstyled ml-3">
                  <li class="my-2">
                    <a
                      class="ios-app-btn"
                      target="_blank"
                      href="https://apps.apple.com/cn/app/id1480840214?l=zh&ls=1"
                    >
                      <img
                        src="https://resources.pzacademy.com/image/www-ui/ios-app.png"
                        width="150"
                        height="50"
                        alt="IOS Store"
                      />
                    </a>
                  </li>
                  <li class="my-2">
                    <!-- <a
                      class="android-app-btn"
                      href="http://class.pzacademy.com/download/pzacademy.apk"
                    >
                      <img
                        src="https://resources.pzacademy.com/image/www-ui/android-app.png"
                        width="150"
                        height="50"
                        alt="IOS Store"
                      />
                    </a> -->
                    <a
                      class="android-app-btn"
                      href="https://class.pzacademy.com/appdown.html"
                    >
                      <img
                        src="https://resources.pzacademy.com/image/www-ui/android-app.png"
                        width="150"
                        height="50"
                        alt="IOS Store"
                      />
                    </a>
                  </li>
                  <li class="my-2 small text-info">扫码下载品职教育APP</li>
                </ul>
              </div>
            </div>
          </li>
          <li class="nav-item ml-3" v-if="p_isLogin">
            <PZLink
              extraClass="btn btn-link text-info border-left pl-4 d-flex pr-0 text-decoration-none"
              :isExtenalPath="isFromClass"
              :linkStr="RedirectUrl.DASHBOARD_PAGE"
            >
              进入课程
              <i class="pz-icon icon-chevron-right"></i>
            </PZLink>
          </li>
          <li class="nav-item px-lg-3" v-if="!p_isLogin">
            <PZLink
              extraClass="btn btn-outline-info rounded-pill"
              :isExtenalPath="isFromClass"
              :linkStr="RedirectUrl.TRAIL_LESSON_20426_PAGE"
            >
              <span class>学习</span>体验
            </PZLink>
          </li>
          <li class="nav-item" v-if="!p_isLogin">
            <a
              href="javascript:undefined"
              class="nav-link"
              @click.prevent="p_gotoLogin"
              >登录 | 注册</a
            >
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
import PZLink from './PZLink.vue';

export default {
  name: 'Header',
  components: {
    PZLink,
  },
  props: {
    isFromClass: Boolean,

    p_isLogin: {
      type: Boolean,
      default: () => false,
    },

    p_gotoLogin: {
      type: Function,
      default: () => {},
    },

    p_logout: {
      type: Function,
      default: () => {},
    },

    RedirectUrl: Object,

    UserInfo: Object,

    p_isInCnIframe: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      isDropDown: false,
      // redirectUrl: "/portal/#"
    };
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
